import { cn } from "@/lib/utils";
import Image from "next/image";

function ProgramProspectsCard({ item }: { item: any }) {
  return (
    <div
      key={item.id}
      className={cn(
        "group flex flex-col gap-6 rounded-3xl",
        "items-start justify-start",
        "p-8",
        "w-full",
        "shadow-lg",
        "sm:h-[292px] md:min-h-[344px] lg:h-[424px] xl:h-[524px]"
      )}
      style={{ backgroundColor: item.desktop_card_color || "#FFFFFF" }}
    >
      {item?.icon && item?.icon !== "" && (
        <div
          className={cn(
            "relative w-10 h-10 flex-shrink-0",
            "lg:w-12 lg:h-12",
            "xl:w-14 xl:h-14"
          )}
        >
          <Image
            src={item?.icon || ""}
            alt={item?.alt_icon || "Program prospect"}
            fill
            className="object-contain transition-all duration-300"
          />
        </div>
      )}

      <div className="flex flex-col gap-4 items-start text-left w-full">
        <p
          className={cn(
            "text-body-1-semibold",
            "sm:text-heading-7-semibold",
            "md:text-body-5-semibold",
            "lg:text-heading-6-semibold",
            "xl:text-heading-3-semibold",
            "line-clamp-2"
          )}
          style={{ color: item?.title_text_color }}
        >
          {item?.text}
        </p>
        <p
          className={cn(
            "text-body-3-regular",
            "sm:text-heading-8-regular",
            "md:text-body-1-regular",
            "lg:text-body-5-regular",
            "xl:text-heading-4-regular",
            "line-clamp-4"
          )}
          style={{ color: item?.description_text_color }}
        >
          {item.description}
        </p>
      </div>
    </div>
  );
}

export default ProgramProspectsCard;
